export const routeHome = '/';
export const routeChat = '/chat';
export const routeChatWithId = '/chat/:type/:id';
export const routeDoccu = '/documentation';
export const routeAbout = '/';